import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import { CloverLogo, SquareLogo, StripeLogo } from '@lendica/components';
import ReceiptIcon from '@mui/icons-material/Receipt';

const services = [
    {
        logo: SquareLogo,
        key: 'square'
    },
    {
        logo: StripeLogo,
        key: 'stripe'
    },
    {
        logo: CloverLogo,
        key: 'clover'
    },
]

export const PointOfSales = ({ company_id, env }: { company_id: string, env: string }) => {
    const [expanded, setExpanded] = useState(false);

    const launchPopup = (service: string) => {
        let win;
        let parameters = "location=1,width=800,height=650";
        parameters += ",left=" + (screen.width - 800) / 2 + ",top=" + (screen.height - 650) / 2;

        if (env === 'idev') {
            win = window.open(`https://micro-oauth-dev.herokuapp.com/oauth/${service}?company_id=${company_id}`, 'connectPopup', parameters);
        } else if (env === 'prod') {
            win = window.open(`https://oauth.app.golendica.com/oauth/${service}?company_id=${company_id}`, 'connectPopup', parameters);
        }
    }

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{
                '&:before': {
                    display: 'none',
                },
                borderRadius: 1,
                boxShadow: 'none',
                paddingTop: 1,
                background: '##EDEDF4',
                border: '1px solid #EDEDF4',
                mt: 2,
                mb: 2,
                paddingBottom: expanded ? 0 : 1
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                color="#FFF"
                sx={{
                    border: 'none',
                    boxShadow: 'none',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ReceiptIcon />
                    <Typography fontWeight={500} ml={2}>Point of Sales</Typography>
                </Box>

            </AccordionSummary>
            <AccordionDetails
                sx={{
                    padding: '0',
                }}
            >
                <Box>
                    {services.map((service, index) => {
                        const Logo = service.logo;

                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    padding: '1rem 1rem',
                                    background: '#f2f2f8',
                                    borderRadius: 1,
                                    marginY: 1,
                                    marginX: 2,
                                    cursor: 'pointer',
                                    height: 28
                                }}
                                component="div"
                                onClick={() => {
                                    launchPopup(service.key)
                                }}
                            >
                                <Logo />
                                <AddIcon />
                            </Box>
                        )
                    })}
                </Box>
            </AccordionDetails>
        </Accordion >
    )
}